export default __webpack_public_path__ + "static/media/logo_Arkademi.f605674d.svg";